import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { message, Input, Row, Table,Button } from 'antd';
import ErrorWrapper from '../../../lib/error_wrapper';
import { showErrorInNotification, schema_to_field, formatMoney } from '../../../lib/util';
import { PopUpForm } from '../../../lib/ui/popupform';
import Title from 'antd/lib/typography/Title';


class GeneralPlugin extends Component {
  constructor(props) {
    super(props)

    this.state = {
      form_data: {},
      form_schema: [],
      selected_plugin: {},
      form_visibility: false
    }

    this.list_plugin = RESTExecutor.list().config({
      url: this.props.api,
    }).callbacks((success) => {

    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.plugins);

    this.post_meta = RESTExecutor.post().config({
      url: this.props.api,
      headers:{
        // Accepts: 'multipart/form-data'
      }
    }).callbacks((success) => {
      message.success("Meta Updated");
      this.list_plugin.execute();
      this.setState({
        form_data: {},
        form_schema: [],
        selected_plugin: {},
        form_visibility: false
      })
    }).connect(props.domains.plugins)

  }

  render() {

    let list_plugin_resp = this.list_plugin.response();
    let post_meta_resp = this.post_meta.response();
    let rowsData = (list_plugin_resp.result && list_plugin_resp.result.rows) || [];
    let rowsMeta = list_plugin_resp.meta || {};

    let filteredData = JSON.parse(JSON.stringify(rowsData));
    if (this.state.query) {
      filteredData = filteredData.filter(({ name = "", id = "", description = "" }) => {
        name = name.toLowerCase();
        id = id.toLowerCase();
        description = description.toLowerCase();
        return name.includes(this.state.query.toLowerCase())
          || id.includes(this.state.query.toLowerCase())
          || description.includes(this.state.query.toLowerCase())
          ;
      });
    }

    const plugin_cols=({
      onAddEditPressed
    })=>{
      return [
      ...this.props.columns,
        {
          title:"Meta",
          dataIndex:'meta_config',
          key:'action',
          width:60,
          textWrap: 'word-break',
          render:(meta_config=[],data)=>{
              return Array.isArray(meta_config)&&meta_config.length>0?<Button onClick={()=>{
                  typeof onAddEditPressed==='function'&&onAddEditPressed(meta_config,data)
              }} type='link'>Meta</Button>:<span></span>
          }
      }
      ]

    }
    return (
      <div>
        <ErrorWrapper 
        error={list_plugin_resp}
          onReload={() => {
            this.list_plugin.execute()
          }}
        >

          <PopUpForm
            title={`Meta for ${this.state.selected_plugin.name || this.state.selected_plugin.id}`}
            forCreate={Object.keys(this.state.form_data).length > 0 ? false : true}
            initialData={this.state.form_data}
            width='80%'
            fields={this.state.form_schema}
            open={this.state.form_visibility}
            networkState={post_meta_resp}
            onClose={() => this.setState({
              form_data: {},
              form_schema: [],
              selected_plugin: {},
              form_visibility: false
            })}
            onSubmit={(data) => {
              console.log("DATA", data);

              // let formData=new FormData();
              
              // Object.keys(data).map((ke)=>{
              //   formData.append(ke,data[ke]);
              // });
              // let MainData=new FormData();
              // MainData.append("plugin_id",this.state.selected_plugin.id);
              // MainData.append("meta",data);

              // this.post_meta.execute(MainData);
              this.post_meta.execute({
                plugin_id: this.state.selected_plugin.id,
                meta: data
              });
              // this.handlePostPatch(data);
            }} />
          <Table
            scroll={{ x: true }}
            loading={list_plugin_resp.fetching}
            columns={plugin_cols({
              onAddEditPressed: (meta_config, data) => {
                this.setState({
                  form_schema: schema_to_field(meta_config),
                  form_data: data.meta_params || {},
                  form_visibility: true,
                  selected_plugin: data
                });

              }
            })}
            pagination={{
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
            }}
            dataSource={filteredData}
            className='main-table' size='small'
            title={() => <div><Row type='flex' justify='space-between' style={{
              alignItems: 'center'
            }}><Title
              type='secondary'
              level={3}

              style={{
                margin: 0
              }}>{this.props.title}</Title>

            </Row><br></br>
              <Row type='flex'
                justify='space-between'
                style={{
                  alignItems: 'center',
                  flexWrap: 'nowrap'
                }}>
                <Input.Search
                  allowClear
                  placeholder="Search For"
                  style={{
                  }} autoFocus
                  value={this.state.query}
                  onChange={(e) => {
                    this.setState({ query: e.target.value })
                  }}
                />
              </Row></div>}
            rowKey={(record) => record.id}
          />

        </ErrorWrapper>
      </div>
    );
  }

  componentDidMount() {
    this.list_plugin.execute()
}
}

export default withDomains(GeneralPlugin,"plugins");
